$(document).ready(function(){
  showDesc();
  accordion();
  determineNav()

  /*** Header ***/
  var headerHeight = $('.navbar--shop').outerHeight();
    $(window).scroll(function(){
    var sticky = $('.navbar--shop'),
        scroll = $(window).scrollTop();
    if (scroll > 0) sticky.addClass('sticky');
    else sticky.removeClass('sticky');
  });

  var headerHeightStudio = $('.navbar--studio').outerHeight();
    $(window).scroll(function(){
    var sticky = $('.navbar--studio'),
        scroll = $(window).scrollTop();
    if (scroll > 0) sticky.addClass('sticky');
    else sticky.removeClass('sticky');
  });

  $('.navbar--shop .navbar-toggler').on('click',function(){
    var heightNav = $(window).height() - $('.navbar--shop').outerHeight();

    if($(this).hasClass('show')) {
      $(this).removeClass('show');
      $('.mobi-submenu, .mobi-cart-mini').show();
      // $('.mobi-account').hide();
      $('#mobiMainNavbar').css('height', '0').removeClass('show');
      $('body').css('overflow', 'visible');
    } else {
      $(this).addClass('show');
      // $('.mobi-submenu, .mobi-cart-mini').hide();
      // $('.mobi-account').show()
      $('#mobiMainNavbar').css('height', heightNav).addClass('show');
      $('body').css('overflow', 'hidden');
    }
  });

  $('body').on('click','.navbar--studio .navbar-toggler',function(){
    var heightNav = $(window).height() - $('.navbar--studio').outerHeight();

    if($(this).hasClass('show')) {
      $(this).removeClass('show');
      $('.mobi-submenu, .mobi-cart-mini').show();
      // $('.mobi-account').hide();
      $('#mobiMainNavbar').css('height', '0').removeClass('show');
      $('body').css('overflow', 'visible');
    } else {
      $(this).addClass('show');
      // $('.mobi-submenu, .mobi-cart-mini').hide();
      // $('.mobi-account').show();
      $('#mobiMainNavbar').css('height', heightNav).addClass('show');
      $('body').css('overflow', 'hidden');
    }
  });

  $('.navbar--shop .mobi-nav-btn').on('click',function(){
    $('.mobi-search-form').hide();
    $(this).parent().find('.dropdown-menu').addClass('show');
  });
  $('.navbar--studio .mobi-nav-btn').on('click',function(){
    $('.mobi-search-form').hide();
    $(this).parent().find('.dropdown-menu').addClass('show');
  });
  $('.navbar--shop .dropdown-header.has-childlink').on('click',function(){
    var $content = $(this).parent().find('.childlink-content');
    if($content.hasClass('show')) {
      $(this).attr('data-before', '+');
      $content.hide().removeClass('show');
    }
    else {
      $(this).parents('.dropdown-menu-content').find('.childlink-content').hide().removeClass('show');
      $(this).parents('.dropdown-menu-content').find('.dropdown-header').attr('data-before', '+')
      $(this).attr('data-before', '-');
      $content.show().addClass('show');
    }
  });

  $('.navbar--studio .dropdown-header.has-childlink').on('click',function(){
    var $content = $(this).parent().find('.childlink-content');
    if($content.hasClass('show')) {
      $(this).attr('data-before', '+');
      $content.hide().removeClass('show');
    }
    else {
      $(this).parents('.dropdown-menu-content').find('.childlink-content').hide().removeClass('show');
      $(this).parents('.dropdown-menu-content').find('.dropdown-header').attr('data-before', '+')
      $(this).attr('data-before', '-');
      $content.show().addClass('show');
    }
  });
  
  $('.nav-back-btn').on('click',function(){
    $('.mobi-search-form').show();
    $(this).parent().removeClass('show');
  });
  /***************** Banner slide *****************/
  $('.section--banner-slide').slick({
  	arrows:true,
    dots:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });

  /***************** Tab with banner *****************/
  $('.tab li').on('click',function(e){
      e.preventDefault();
      activeTab(this);
  });

  activeTab($('.tab li:first-child'));

  /***************** JS slide new in product *****************/
  $('.block--collection').slick({
    slidesToShow: 5,
    slidesToScroll: 2,
    dots:true,
    arrows:true,
    responsive:[
      {
        breakpoint: 768,
        settings: {
          dots:false,
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots:false,
          slidesToShow: 3.05,
          slidesToScroll: 2,
          arrows:false
        }
      }
    ]
  });

  $('.gift-guide-slick').slick({
  	arrows:true,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
    responsive:[
      {
        breakpoint: 768,
        settings: {
          dots:false,
          slidesToShow: 3.5,
          slidesToScroll: 1,
          arrows:false,
          infinite: false
        }
      }
    ]
  });
});

/***************** Active tab with banner *****************/
function activeTab(obj){
  $('.section--tab ul li').removeClass('active');
  $(obj).addClass('active');
  var id = $(obj).find('a').attr('href');
  $('.tab-item').hide();
  $(id).show();
}

/***************** Collection membership template *****************/
function showDesc(){
  $('.read-more-desc').on('click',function(){
    var $parent = $(this).parent();
    if ($parent.hasClass('show-full')) {
      $parent.removeClass('show-full').find('.read-more-desc').html('+');
    } else {
      $parent.addClass('show-full').find('.read-more-desc').html('-');
    }
  });
}
function accordion(){
  $('.accordion-footer--title').on('click',function(){
    var $parent = $(this).parent();
    if ($parent.hasClass('active')) {
      $parent.removeClass('active').find('.accordion-footer--title span').html('+');
    } else {
      $('.accordion-footer--block').removeClass('active');
      $('.accordion-footer--block .accordion-footer--title span').html('+');
      $parent.addClass('active').find('.accordion-footer--title span').html('-');
    }
  });
}

/****** Menu Hover Events *******/
function determineNav() {
  var desktopMenu = document.getElementById('mainNavbar')
  var desktopStyles = getComputedStyle(desktopMenu)
  if(desktopStyles.display =='flex') {
    var cell =document.querySelectorAll('.nav-item.dropdown');
    for(var i=0;i<cell.length;i++){
      cell[i].addEventListener('mouseover',dropdownCallback,false);
    }

    var cell =document.querySelectorAll('.dropdown-menu');
    for(var i=0;i<cell.length;i++){
      cell[i].addEventListener('mouseleave',closeDropdown,false);
    }

    function dropdownCallback(){
      document.querySelectorAll('.nav-item.dropdown');
      var cell =document.querySelectorAll('.nav-item.dropdown');
      for(var i=0;i<cell.length;i++){
        cell[i].classList.remove('show');
      }
      var cellContainer =document.querySelectorAll('.dropdown-menu');
      for(var i=0;i<cellContainer.length;i++){
        cellContainer[i].classList.remove('show');
      }
      this.classList.add('show');
      this.querySelector('.dropdown-menu').classList.add('show');
    }

    function closeDropdown(){
      if(this.classList.contains('show')){
        this.classList.remove('show');
        this.parentElement.classList.remove('show');
      };
    }
  } 
}

